export function CrossIcon() {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10 20C8.2 20 6.53333 19.55 5 18.65C3.46667 17.75 2.25 16.5333 1.35 15C0.45 13.4667 0 11.8 0 10C0 8.2 0.45 6.53333 1.35 5C2.25 3.46667 3.46667 2.25 5 1.35C6.53333 0.45 8.2 0 10 0C11.8 0 13.4667 0.45 15 1.35C16.5333 2.25 17.75 3.46667 18.65 5C19.55 6.53333 20 8.2 20 10C20 11.8 19.55 13.4667 18.65 15C17.75 16.5333 16.5333 17.75 15 18.65C13.4667 19.55 11.8 20 10 20ZM10 11.6L13.2 14.8L14.8 13.2L11.6 10L14.8 6.8L13.2 5.2L10 8.4L6.8 5.2L5.2 6.8L8.4 10L5.2 13.2L6.8 14.8L10 11.6Z"
                fill="#EF4444"
            />
        </svg>
    )
}
